// extracted by mini-css-extract-plugin
export default {"page":"Home_page__UCLJa","pageContent":"Home_pageContent__3nFE9","header":"Home_header__opf7Q","inputContainer":"Home_inputContainer__qF8nd"};